import type { QueryClient } from '@tanstack/react-query';
import { ENTITY_QUERY_KEYS } from '../constants/queryKeys';
import type { EntityQueryKey } from '../types/types';

/**
 * Invalidate every cached react-query whose key contains a string segment
 * registered under one of the given entity buckets in `ENTITY_QUERY_KEYS`.
 */
export const invalidateEntityQueries = (
  queryClient: QueryClient,
  entities: EntityQueryKey | readonly EntityQueryKey[],
): Promise<void> => {
  const entityList: readonly EntityQueryKey[] = Array.isArray(entities)
    ? entities
    : [entities];
  if (entityList.length === 0) {
    return Promise.resolve();
  }

  const keysToInvalidate = new Set<string>();
  for (const entity of entityList) {
    for (const key of ENTITY_QUERY_KEYS[entity]) {
      keysToInvalidate.add(key);
    }
  }

  return queryClient.invalidateQueries({
    predicate: (query) =>
      query.queryKey.some(
        (segment) =>
          typeof segment === 'string' && keysToInvalidate.has(segment),
      ),
  });
};
